import apiClient from './apiClient';

/**
 * Authentication utility functions for the RGM Museum application
 */
const authClient = {
  /**
   * Login user with username and password
   * @param {string} userName - User's username
   * @param {string} password - User's password
   * @returns {Promise} - Promise resolving to user data or error
   */
  login: async (userName, password) => {
    try {
      const response = await apiClient.post('/users/login', { userName, password });
      
      // Store user data in localStorage for persistence
      if (response.data && response.data.user) {
        localStorage.setItem('rgmUser', JSON.stringify(response.data.user));
      }
      
      return response.data;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  },

  /**
   * Check if user is authenticated
   * @returns {boolean} - True if user is authenticated, false otherwise
   */
  isAuthenticated: () => {
    const user = localStorage.getItem('rgmUser');
    return !!user;
  },

  /**
   * Get current user data
   * @returns {Object|null} - User data or null if not authenticated
   */
  getCurrentUser: () => {
    try {
      const user = localStorage.getItem('rgmUser');
      return user ? JSON.parse(user) : null;
    } catch (error) {
      console.error('Error getting current user:', error);
      return null;
    }
  },

  /**
   * Check if current user is an admin
   * @returns {boolean} - True if user is admin, false otherwise
   */
  isAdmin: () => {
    try {
      const user = localStorage.getItem('rgmUser');
      if (!user) return false;
      const userData = JSON.parse(user);
      return userData.isAdmin === 1 || userData.isAdmin === true;
    } catch (error) {
      console.error('Error checking admin status:', error);
      return false;
    }
  },

  /**
   * Update user data in localStorage
   * @param {Object} userData - Updated user data
   */
  updateUser: (userData) => {
    try {
      localStorage.setItem('rgmUser', JSON.stringify(userData));
    } catch (error) {
      console.error('Error updating user data:', error);
    }
  },

  /**
   * Logout user
   */
  logout: () => {
    localStorage.removeItem('rgmUser');
  }
};

export default authClient;
